// extracted by mini-css-extract-plugin
export default {"list":"-kCE1","list-item":"UCom2","list-item-number":"-C0ts","list-item-text":"PFkfx","pic":"_2NYyN","note":"vkWyh","skeleton-progress":"uimWc"};